import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useExplorer } from "@/context/ExplorerContext";
import { Eyebrow, Section } from "@/components/lurio/Primitives";
import { Reveal } from "@/components/lurio/Motion";

export default function FAQ() {
  const { t } = useExplorer();
  return (
    <Section id="faq">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal><Eyebrow className="mb-5">{t.faq.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl">{t.faq.title}</h2></Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible data-testid="faq-accordion" className="divide-y-0">
            {t.faq.items.map((it, i) => (
              <AccordionItem key={i} value={`q${i}`} className="border-ink/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="min-h-[56px] gap-4 py-5 text-start font-serif text-xl font-bold leading-[1.4] text-ink hover:no-underline sm:text-2xl [&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0 [&>svg]:text-coral">
                  <span className="flex gap-4"><span className="font-latin font-light text-gold" dir="ltr">0{i + 1}</span>{it.q}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 ps-10 text-[1.05rem] leading-[1.85] text-ink-soft">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </Section>
  );
}
